module.exports = __webpack_public_path__ + "static/media/primary_Health_Care_Infographic.8899de9f.pdf";